import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';

export const templateMspInProductTrialsStartTrialPopUp = document.createElement('template');

templateMspInProductTrialsStartTrialPopUp.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

    <div class='wrapper wrapper-trial'>
      <p id='start-trial-info'></p>
      <p id='start-trial-country-industry-info'></p>
      <div class='form-wrapper' id='company-details-form-wrapper'>
        <div class='form-section'>
            <div class="msp-country-form-section">
              <gz-form-field id='msp-country-form-field' class='label-mw-250' label='' required>
                <gz-dropdown gz-form-input localFiltering canDelete combobox type='dropdown'></gz-dropdown>
                <gz-input-error></gz-input-error>
             </gz-form-field>

              <gz-form-field id='msp-state-form-field' class='label-mw-250 hidden' label='' required>
                <gz-dropdown gz-form-input localFiltering canDelete combobox type='dropdown'></gz-dropdown>
                <gz-input-error></gz-input-error>
              </gz-form-field>
            </div>
            <div class="msp-industry-form-section">
              <gz-form-field id='msp-industry-form-field' class='label-mw-250' label='' required>
                <gz-dropdown gz-form-input localFiltering canDelete combobox type='dropdown'></gz-dropdown>
                <gz-input-error></gz-input-error>
              </gz-form-field>
            </div>
        </div>
      </div>
    </div>
`;
